module.exports = __webpack_public_path__ + "static/foreword2-1c233bad934c55c592d09e453524bd7e.png";